import { render } from "./UsersCreateView.vue?vue&type=template&id=c6ec0870&scoped=true"
import script from "./UsersCreateView.vue?vue&type=script&lang=js"
export * from "./UsersCreateView.vue?vue&type=script&lang=js"

import "./UsersCreateView.vue?vue&type=style&index=0&id=c6ec0870&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6ec0870"]])

export default __exports__